import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Container } from "react-bootstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Modal from "react-modal";
import CommonStructured from "../../common-components/CommonStructured";
import CmnFilters from "../../lead-management/common/CmnFilters";
import {
  fetchGymTransferData,
  fetchGymTransferRequestData,
} from "../../../redux/transfer-reducers/transferSlice";
import GymTransferListings from "./GymTransferListings";
import GymTransferForm from "./GymTransferForm";
import GymTransferRequestListings from "../membership-transfer/transfer-request/GymTransferRequestListings";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import MembershipTransferRequestForm from "../membership-transfer/transfer-request/MembershipTransferRequestForm";
import PlanDetails from "../membership-transfer/plan-detail/PlanDetails";
import ViewDetails from "../membership-transfer/plan-detail/ViewDetails";
import HelmetWrapper from "../../../HelmetWrapper";

const GymTransferStructure = ({ userInfoData }) => {
  const dispatch = useDispatch();

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: "",
    selAddedby: "",
    selectedApprovalStatus: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_from: allFilters.selectedGym?.value || "",
    transfered_by: allFilters.selAddedby?.value || "",
    status: allFilters.selectedApprovalStatus?.value || "",
    start_date: allFilters.leadAddDateFrom || "",
    end_date: allFilters.leadAddDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const iniModvalues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const handleTabSelect = (index) => {
    setSelectedTab(index);
    setIsPage(0);
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const getGymTransferRequestList = () => {
    dispatch(
      fetchGymTransferRequestData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  function getGymTransferList(filters) {
    dispatch(
      fetchGymTransferData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getCombineReload() {
    getGymTransferList(filters);
    getGymTransferRequestList(filters);
  }

  useEffect(() => {
    getGymTransferRequestList(filters);
    getGymTransferList(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_from: allFilters.selectedGym?.value || "",
      transfered_by: allFilters.selAddedby?.value || "",
      status: allFilters.selectedApprovalStatus?.value || "",
      start_date: allFilters.leadAddDateFrom || "",
      end_date: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selAddedby,
    allFilters.selectedApprovalStatus,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Gym Transfer">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Modal"
          ariaHideApp={false}>
          <div
            className={`createNewCTOModalContainer ${
              modValues.modName === "view_details"
                ? "mod-width-70p"
                : "mod-width-50p"
            }`}>
            <ModalHeadAndClose
              title={
                modValues.modName === "approval"
                  ? "Approve/Reject Gym Transfer Request"
                  : modValues.modName === "add"
                  ? "Gym Transfer"
                  : modValues.modName === "plan-details"
                  ? modValues.rowData?.user_from_name
                  : modValues.modName?.replace(/_/g, " ")
              }
              onClose={onCloseModal}
            />

            {modValues.modName === "add" ? (
              <GymTransferForm
                userInfoData={userInfoData}
                rowData={modValues.rowData}
                closeModal={onCloseModal}
                callFunction={getCombineReload}
              />
            ) : modValues.modName === "approval" ? (
              <MembershipTransferRequestForm
                userInfoData={userInfoData}
                rowData={modValues.rowData}
                callFunction={getCombineReload}
                onCloseModal={onCloseModal}
                from="gym-transfer"
              />
            ) : modValues.modName === "remarks" ? (
              <div className="discussionModalMessage mt30">
                <p className="message">
                  {modValues.rowData?.aprv_rej_remarks ||
                    "No Content Available"}
                </p>
              </div>
            ) : modValues.modName === "plan-details" ? (
              <PlanDetails rowData={modValues.rowData} />
            ) : modValues.modName === "view_details" ? (
              <ViewDetails
                rowData={modValues.rowData}
                isPaymentLinkListings={modValues.isPaymentLinkListings}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Gym Transfer"}
              createBtnTxt={"➤ New Gym Transfer"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "add",
                }))
              }
              isReload={getCombineReload}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from={"membership-transfer"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={false}
              searchPlaceHolder="Search by member info"
              clickedCard="gym-transfer"
              selectedTab={selectedTab}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="discount-payments-tabs bgTransParent odm-wati-container">
              <Tabs onSelect={handleTabSelect}>
                <TabList>
                  <Tab>Gym Transfer</Tab>
                  <Tab>Gym Transfer Request</Tab>
                </TabList>
                <TabPanel>
                  <GymTransferListings
                    isPage={isPage}
                    setIsPage={setIsPage}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                    setModValues={setModValues}
                  />
                </TabPanel>
                <TabPanel>
                  <GymTransferRequestListings
                    isPage={isPage}
                    setIsPage={setIsPage}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                    setModValues={setModValues}
                    userInfoData={userInfoData}
                  />
                </TabPanel>
              </Tabs>
            </div>
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default GymTransferStructure;
